module.exports = __webpack_public_path__ + "img/mercato.a28b8bf9.jpeg";